let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fGPpk")).then(() => parcelRequire('2tm8x'));